import React, { useState } from 'react';
import { TIPO_LABELS, TIPOS_GROUPED } from '../data/orientaciones';
import { format, parseISO } from 'date-fns';
import { es } from 'date-fns/locale';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';
import * as XLSX from 'xlsx';

function exportarExcel(casos) {
  const wb = XLSX.utils.book_new();
  const hoy = format(new Date(),'dd/MM/yyyy');
  const filas = casos.map((c,i) => ({
    'N°':i+1,'Código SIGERD':c.codigoCentro||'—','Centro Educativo':c.centro||'—',
    'Tipo de Caso':TIPO_LABELS[c.tipo]||c.tipo||'—','Solicitante':c.solicitante||'—','Rol':c.rol||'—',
    'Teléfono':c.telefono||'—','Correo':c.email||'—','Enviado a':c.destinatario||'—','Estado':c.estado||'—',
    'Fecha del Caso':c.fecha||'—','Fecha Límite':c.fechaAlerta||'—','Descripción':c.descripcion||'—',
    'Total Seguimientos':(c.seguimientos||[]).length,
    'Último Seguimiento':c.seguimientos?.length?c.seguimientos[c.seguimientos.length-1].nota:'—',
    'Fecha Registro':c.creadoEn?c.creadoEn.split('T')[0]:'—',
  }));
  const ws1 = XLSX.utils.json_to_sheet(filas);
  ws1['!cols'] = [{wch:4},{wch:12},{wch:36},{wch:28},{wch:24},{wch:22},{wch:14},{wch:26},{wch:30},{wch:12},{wch:14},{wch:14},{wch:40},{wch:8},{wch:40},{wch:14}];
  XLSX.utils.book_append_sheet(wb, ws1, 'Casos');

  const porTipo = {};
  casos.forEach(c => {
    const t = TIPO_LABELS[c.tipo]||c.tipo||'Sin tipo';
    if (!porTipo[t]) porTipo[t]={total:0,recibido:0,enProceso:0,orientado:0,cerrado:0};
    porTipo[t].total++; if(c.estado==='Recibido')porTipo[t].recibido++; if(c.estado==='En proceso')porTipo[t].enProceso++; if(c.estado==='Orientado')porTipo[t].orientado++; if(c.estado==='Cerrado')porTipo[t].cerrado++;
  });
  const filasR = [...Object.entries(porTipo).map(([tipo,d])=>({'Tipo de Caso':tipo,'Total':d.total,'Recibido':d.recibido,'En Proceso':d.enProceso,'Orientado':d.orientado,'Cerrado':d.cerrado})),
    {'Tipo de Caso':'TOTAL GENERAL','Total':casos.length,'Recibido':casos.filter(c=>c.estado==='Recibido').length,'En Proceso':casos.filter(c=>c.estado==='En proceso').length,'Orientado':casos.filter(c=>c.estado==='Orientado').length,'Cerrado':casos.filter(c=>c.estado==='Cerrado').length}];
  const ws2 = XLSX.utils.json_to_sheet(filasR);
  XLSX.utils.book_append_sheet(wb, ws2, 'Resumen por Tipo');

  const ws4 = XLSX.utils.aoa_to_sheet([['MINISTERIO DE EDUCACIÓN DE LA REPÚBLICA DOMINICANA'],['Dirección de Acreditación de Centros Educativos — DACE'],[''],['REPORTE DE CASOS — INSTITUCIONES EDUCATIVAS PRIVADAS'],['Distrito Educativo 1102 — Puerto Plata'],[''],['Fecha: '+hoy],['Total: '+casos.length]]);
  XLSX.utils.book_append_sheet(wb, ws4, 'Portada');
  XLSX.writeFile(wb, `Reporte_Casos_Distrito1102_${format(new Date(),'yyyy-MM-dd')}.xlsx`);
}

const ESTADOS = ['Recibido','En proceso','Orientado','Cerrado'];
const ESTADO_COLORS = { Recibido:{bg:'#eff6ff',color:'#1d4ed8',border:'#bfdbfe'}, 'En proceso':{bg:'#fffbeb',color:'#b45309',border:'#fde68a'}, Orientado:{bg:'#f0fdf4',color:'#15803d',border:'#bbf7d0'}, Cerrado:{bg:'#f3f4f6',color:'#6b7280',border:'#e5e7eb'} };

function EstadoSelector({ caso }) {
  const [open, setOpen] = useState(false);
  const [saving, setSaving] = useState(false);
  const col = ESTADO_COLORS[caso.estado]||ESTADO_COLORS['Recibido'];
  async function cambiar(e) {
    if (e===caso.estado){setOpen(false);return;}
    setSaving(true);
    try {
      await updateDoc(doc(db,'casos',caso.id),{ estado:e, seguimientos:[...(caso.seguimientos||[]),{fecha:new Date().toISOString().split('T')[0],nota:`Estado cambiado a: ${e}`,destinatario:'',estado:e}] });
    } catch { alert('Error al cambiar estado.'); }
    setSaving(false); setOpen(false);
  }
  return (
    <div style={{ position:'relative', display:'inline-block' }}>
      <div onClick={e=>{e.stopPropagation();setOpen(o=>!o)}} style={{ display:'inline-flex',alignItems:'center',gap:5,padding:'3px 9px',borderRadius:20,cursor:'pointer',fontSize:11,fontWeight:700,userSelect:'none',background:col.bg,color:col.color,border:`1px solid ${col.border}` }}>
        {saving?'...':caso.estado}<svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><path d="M7 10l5 5 5-5z"/></svg>
      </div>
      {open && (
        <div style={{ position:'absolute',top:'calc(100% + 4px)',left:0,background:'#fff',border:'1.5px solid #e5e7eb',borderRadius:10,boxShadow:'0 8px 24px rgba(0,0,0,.14)',zIndex:999,minWidth:140,overflow:'hidden' }} onClick={e=>e.stopPropagation()}>
          {ESTADOS.map(e => { const c=ESTADO_COLORS[e]; return (
            <div key={e} onClick={()=>cambiar(e)} style={{ padding:'9px 14px',cursor:'pointer',fontSize:12,fontWeight:700,color:c.color,background:caso.estado===e?c.bg:'#fff',display:'flex',alignItems:'center',gap:7,borderBottom:'1px solid #f3f4f6' }}
              onMouseEnter={ev=>ev.currentTarget.style.background=c.bg} onMouseLeave={ev=>ev.currentTarget.style.background=caso.estado===e?c.bg:'#fff'}>
              <div style={{ width:8,height:8,borderRadius:'50%',background:c.color,flexShrink:0 }}/>{e}
              {caso.estado===e&&<svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" style={{marginLeft:'auto'}}><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/></svg>}
            </div>
          );})}
        </div>
      )}
      {open && <div style={{ position:'fixed',inset:0,zIndex:998 }} onClick={()=>setOpen(false)}/>}
    </div>
  );
}

export default function Casos({ casos, onVerDetalle, onAbrirSeguimiento, userRole }) {
  const [filtroTipo, setFiltroTipo] = useState('');
  const [filtroEstado, setFiltroEstado] = useState('');
  const [buscar, setBuscar] = useState('');
  const [exportando, setExportando] = useState(false);
  const puedeEditar = userRole !== 'secretaria';

  const filtrados = casos.filter(c => {
    if (filtroTipo && c.tipo !== filtroTipo) return false;
    if (filtroEstado && c.estado !== filtroEstado) return false;
    const q = buscar.toLowerCase();
    if (q && !c.centro?.toLowerCase().includes(q) && !c.solicitante?.toLowerCase().includes(q)) return false;
    return true;
  });

  function handleExportar() {
    if (!filtrados.length){alert('No hay casos para exportar.');return;}
    setExportando(true);
    setTimeout(()=>{exportarExcel(filtrados);setExportando(false);},100);
  }

  return (
    <div className="card">
      <div className="card-header">
        <h3>Casos registrados ({filtrados.length})</h3>
        {puedeEditar && (
          <button className="btn btn-sm" onClick={handleExportar} disabled={exportando} style={{ background:'linear-gradient(135deg,#15803d,#009A44)', color:'#fff', border:'none', display:'flex', alignItems:'center', gap:6 }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/></svg>
            {exportando?'Generando...':'Exportar Excel'}
          </button>
        )}
      </div>
      <div className="filters-bar">
        <select value={filtroTipo} onChange={e=>setFiltroTipo(e.target.value)}>
          <option value="">Todos los tipos</option>
          {TIPOS_GROUPED.map(g=><optgroup key={g.group} label={g.group}>{g.options.map(o=><option key={o.value} value={o.value}>{o.label}</option>)}</optgroup>)}
        </select>
        <select value={filtroEstado} onChange={e=>setFiltroEstado(e.target.value)}>
          <option value="">Todos los estados</option>
          <option>Recibido</option><option>En proceso</option><option>Orientado</option><option>Cerrado</option>
        </select>
        <input type="text" placeholder="Buscar por centro o solicitante..." value={buscar} onChange={e=>setBuscar(e.target.value)} />
      </div>
      <div className="table-wrap">
        <table>
          <thead><tr><th>Centro educativo</th><th>Tipo de caso</th><th>Solicitante</th><th>Enviado a</th><th>Alerta</th><th>Estado</th><th>Fecha</th><th></th></tr></thead>
          <tbody>
            {filtrados.length===0 ? <tr><td colSpan={8} style={{textAlign:'center',color:'var(--gray-400)',padding:'32px'}}>Sin resultados.</td></tr> :
              filtrados.map(c => {
                const hoy=new Date(), alerta=c.fechaAlerta?new Date(c.fechaAlerta):null;
                const dias=alerta?Math.ceil((alerta-hoy)/(1000*60*60*24)):null;
                return (
                  <tr key={c.id} onClick={()=>onVerDetalle(c.id)} style={{ cursor:'pointer' }}>
                    <td><strong>{c.centro}</strong>{c.codigoCentro&&c.codigoCentro!=='NUEVO'&&<div style={{fontSize:10,marginTop:2}}><span style={{background:'linear-gradient(135deg,#002D62,#0a3d80)',color:'#fff',padding:'1px 7px',borderRadius:20,fontSize:10,fontWeight:700}}>{c.codigoCentro}</span></div>}</td>
                    <td><span className="chip-tipo">{TIPO_LABELS[c.tipo]||c.tipo}</span></td>
                    <td>{c.solicitante}{c.telefono&&<div style={{fontSize:11,color:'var(--gray-400)'}}>{c.telefono}</div>}</td>
                    <td>{c.destinatario?<span className="destinatario-tag">→ {c.destinatario}</span>:<span style={{color:'var(--gray-300)',fontSize:12}}>—</span>}</td>
                    <td>{dias!==null?<span className={`chip ${dias<0?'chip-red':dias<=7?'chip-amber':'chip-gray'}`}>{dias<0?`Vencida ${Math.abs(dias)}d`:dias===0?'Hoy':`${dias}d`}</span>:'—'}</td>
                    <td onClick={e=>e.stopPropagation()}>{puedeEditar?<EstadoSelector caso={c}/>:<span className={`chip ${c.estado==='Recibido'?'chip-blue':c.estado==='En proceso'?'chip-amber':c.estado==='Orientado'?'chip-green':'chip-gray'}`}>{c.estado}</span>}</td>
                    <td style={{fontSize:12,color:'var(--gray-500)',whiteSpace:'nowrap'}}>{c.fecha?format(parseISO(c.fecha),'dd MMM yyyy',{locale:es}):'—'}</td>
                    <td onClick={e=>e.stopPropagation()}>{puedeEditar&&<button className="btn btn-sm" onClick={()=>onAbrirSeguimiento(c)}>+ Seguimiento</button>}</td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
